import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FileService from "../services/file.service";
import * as TbIcons from 'react-icons/tb';
import * as AiIcons from 'react-icons/ai';
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";

const API_PATH = "requests";

function ViewRequest({ history, match }) {

  const [requests, setRequests] = useState([]);
  const [fileInfos, setFileInfos] = useState([]);
  const { id } = match.params;
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);
  const user = AuthService.getCurrentUser();
  const FILES_URL = "https://db.irli.org:8080/api/files/";

  const styles = {
    div: {
      whiteSpace: "pre-line"
    }
  }

  useEffect(() => {

    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.get(API_PATH, id).then(x => {
      var request = x.data;

      var agency_names_to_string = "";
      var agencies = request.agency;
      for (var i in agencies) {
        agency_names_to_string += i == agencies.length - 1 ? agencies[i].name : agencies[i].name + ", ";
      }
      request.agencies = agency_names_to_string

      var contact_names_to_string = "";
      var contacts = request.agency_contacts;
      for (var i in contacts) {
        contact_names_to_string += i == contacts.length - 1 ? contacts[i].name : contacts[i].name + ", ";
      }
      request.contacts = contact_names_to_string

      setRequests(request);
      console.log(request);
      var documents = [];
      documents = request.documents;
      FileService.getFiles().then((response) => {
        var files = [];
        for (var x in documents) {
          var file = new Object();
          file.name = documents[x];
          file.url = FILES_URL + file.name;
          files.push(file);
        }
        console.log("file infos: " + JSON.stringify(files));
        setFileInfos(files); // previously response.data
      });
    });
  }, []);

  return (

    <div>

      <table class="table">
        <div >
          <button style={{ position: 'sticky', left: 0, top: 25, zIndex: 1 }} onClick={() => history.goBack()}><TbIcons.TbArrowBack color='black' size={38} /></button>

        </div>
        <div style={{ position: 'sticky' }}>
          {(mod || admin) && (
            <Link to={`../edit/${id}`} style={{ position: 'relative', left: 0, top: -1, marginTop: 15 }} className="btn btn-sm btn-primary mr-2"> <AiIcons.AiTwotoneEdit size={22} /> </Link>
          )}
        </div>
        <thead>
          <tr>

          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Agency Names:</th>
            <td>{requests.agency}</td>
          </tr>

          <tr>
            <th scope="row">Agency Contact Names:</th>
            <ol>
              {requests.agency_contacts?.map((reptile) => (
                <li>{reptile.name}</li>
              ))}
            </ol>
          </tr>

          <tr>

            <th scope="row">Agency Tracking Numbers:</th>
            {/* {user &&  ( */}
            <td>{requests.agency_tracking_numbers}</td>
            {/* // )} */}
          </tr>
          <tr>
            <th scope="row">Category:</th>
            {/* {user &&  ( */}
            <td>{requests.category}</td>
            {/* // )} */}
          </tr>
          <tr>

            <th scope="row">Short Description:</th>
            {/* {user &&  ( */}
            <td style={styles.div}>
              {requests.short_description}

            </td>
            {/* )} */}
          </tr>
          <tr>
            <th scope="row">Current Status:</th>
            <td>{requests.current_status}</td>
          </tr>

          <tr>
            <th scope="row">Subject:</th>
            {/* {user &&  ( */}
            <td style={styles.div}>{requests.subject}</td>
            {/* )} */}
          </tr>

          <tr>
            <th scope="row">Documents:</th>
            <div className="card">
              {/*<div className="card-header">Documents</div>*/}
              <ul className="list-group list-group-flush">
                {fileInfos && fileInfos.map((file, index) => (
                  <li className="list-group-item" key={index}>
                    <a href={file.url}>{file.name} </a>
                  </li>
                ))}
              </ul>
            </div>
          </tr>

          <tr>
            <th scope="row">Submission Date:</th>
            <td style={styles.div}>{requests.submission_date}</td>
          </tr>

          <tr>
            <th scope="row">Acknowledgement Date:</th>
            <td style={styles.div}>{requests.acknowledgement_date}</td>
          </tr>

          <tr>
            <th scope="row">Record received:</th>
            <td style={styles.div}>{requests.records_received}</td>
          </tr>

          <tr>
            <th scope="row">Urgent:</th>
            <td style={styles.div}>{requests.urgent}</td>
          </tr>

          <tr>
            <th scope="row">Overdue:</th>
            <td style={styles.div}>{requests.overdue}</td>
          </tr>

        </tbody>
      </table>
    </div >
  );

}

export { ViewRequest };